/** Quick-fill purposes under the Personal Account form's Purpose field. */
export const USE_CASES = [
  'Personal Trading',
  'Strategy Testing',
  'Content Creation',
  'Community Demos',
  'Team Training',
];
